import { createContext, useContext } from "react";
import type { ContentItem } from "@/types/content";

interface ContentContextType {
  content: ContentItem | null;
}

const ContentContext = createContext<ContentContextType>({ content: null });

export const ContentProvider = ({ content, children }: { content: ContentItem; children: React.ReactNode }) => (
  <ContentContext.Provider value={{ content }}>
    {children}
  </ContentContext.Provider>
);

export const useContentContext = () => useContext(ContentContext);
